











import {Component, Prop, Vue} from 'vue-property-decorator';
import CollapsibleTable from '../common/CollapsibleTable.vue';
import UnconfirmedReports from './UnconfirmedReports.vue';
import {generateLangSubscriptions, observeProp} from '@/components/observe';

@Component<UserUnconfirmedReports>({
  components: {
    UnconfirmedReports,
    CollapsibleTable,
  },
  subscriptions() {
    return generateLangSubscriptions(observeProp<string>(this, 'lang'));
  },
})
export default class UserUnconfirmedReports extends Vue {
  @Prop() public lang!: string;
  @Prop() public reports!: any[];
  @Prop() public isLoading!: boolean;
}
